export function objectHasValues<T extends object>(
	target: T | undefined | null
): target is T {
	if (!target) return false;
	return Object.values(target).some((value) =>
		typeof value === "object" ? objectHasValues(value) : !!value
	);
}
